import * as _ from 'lodash';
import * as d from "../../assets/domains.json"
import * as crypto from "crypto-js"
import * as Base64 from "crypto-js/enc-base64"
import * as Utf8 from "crypto-js/enc-utf8"
import {IConfig} from '../interface/IConfig';
// import * as SHA256 from "crypto-js/sha256"
// import * as crypto from "crypto"


let resolvedConfig: IConfig | undefined;
const DEMO_ENV = "demo";
const POLL_FREQUENCY = 200;
const SEPOLIA_ETHERSCAN = 'https://sepolia.etherscan.io/tx/';

const domains = {...d}

function getSafeDomainData(domainName: string): _.Dictionary<any> | undefined {
    var domainData = getDomainData(domainName)
    if (_.isEmpty(domainData)) return undefined
    return domainData
}

function digestMessage(nonce: string, message: string) {
    const hashDigest = crypto.SHA256(nonce + message);
    return Base64.stringify(hashDigest);
}

function getDomainData(domainName: string): _.Dictionary<any> {
    var returnData = {} as unknown as _.Dictionary<any>
    var domainDict = domains as unknown as _.Dictionary<any>
    const hash = digestMessage(domainDict["nonce"] as string, domainName);
    if (hash in domainDict["data"]) {
        var domainData = (domainDict["data"] as _.Dictionary<any>)[hash] as unknown as _.Dictionary<any>
        for (var k in domainData) {
            // console.log(k, domainData[k], digestMessage( domainDict["nonce"] as string, domainData[k]), Base64.parse(domainData[k]).toString(crypto.Utf8))
            returnData[k] = Base64.parse(domainData[k]).toString(Utf8);
        }
    }
    return returnData
}
function resolveEnvConfigData(): _.Dictionary<any> {
    const host = location.host.split(':')[0];
    var returnData = getDomainData(host)
    returnData["env"] = returnData["env"]  || returnData["prod_env"]
    var env = returnData["env"] || "dev"
    returnData["env"] = env;
    returnData["chain"] = returnData["chain"] || "ETHEREUM";
    var envData = getDomainData(`${env}_api`)
    for (var k in envData) {
        if (k != "domain") {
            if (k == "supportedChains") {
                returnData[k] = envData[k].split(",")
            } else {
                returnData[k] = envData[k]
            }
        }
    }

    var apiData = getDomainData(`apiEndpoints`)
    for (var k in apiData) {
        if (k != "domain") {
            if (k != "wss") {
                returnData[k] = (envData["restApi"] || "") + apiData[k]
            } else {
                returnData[k] = apiData[k]
            }

        }

    }
    console.log("returnData", returnData)
    return returnData
}



const getConfig = async function (): Promise<IConfig> {
    if (resolvedConfig) return resolvedConfig

    const host = location.host.split(':')[0];
    var returnData = getDomainData(host)
    if (!(returnData["env"] || returnData["prod_env"])) {
        const fetchedJson = await fetch("/config/configuration.properties").then(res => res.json());

        domains["data"][digestMessage(domains["nonce"], "dev_api")] = {
            "siweDomain": Base64.stringify(Utf8.parse(fetchedJson.siweDomain)),
            "api": Base64.stringify(Utf8.parse(fetchedJson.api)),
            "wss": Base64.stringify(Utf8.parse(fetchedJson.wss)),
            "restApi": Base64.stringify(Utf8.parse(fetchedJson.restApi)),
            "supportedChains": Base64.stringify(Utf8.parse(fetchedJson.supportedChains)),
        };
        for (let chain of fetchedJson.supportedChains.split(",")) {
            const vals = fetchedJson.chainConfigs[chain];
            domains["data"][digestMessage(domains["nonce"], "chain_" + chain)] = {
                "siweDomain": Base64.stringify(Utf8.parse(vals.siweDomain)),
                "chainId": Base64.stringify(Utf8.parse(vals.chainId)),
                "rpcUrl": Base64.stringify(Utf8.parse(vals.rpcUrl)),
                "txExplorerUrl": Base64.stringify(Utf8.parse(vals.txExplorerUrl)),
                "token": Base64.stringify(Utf8.parse(vals.token)),
                "smartContractAddress": Base64.stringify(Utf8.parse(vals.smartContractAddress)),
                "dtwContractAddress": Base64.stringify(Utf8.parse(vals.dtwContractAddress)),
                "wethContractAddress": Base64.stringify(Utf8.parse(vals.wethContractAddress)),
                "whitelistSmartContractAddress": Base64.stringify(Utf8.parse(vals.whitelistSmartContractAddress)),
                "liquidityPoolSmartContractAddress": Base64.stringify(Utf8.parse(vals.liquidityPoolSmartContractAddress)),
                "leverageSmartContractAddress": Base64.stringify(Utf8.parse(vals.leverageSmartContractAddress)),
                "smartContractFeePercentage": Base64.stringify(Utf8.parse(vals.smartContractFeePercentage)),
                "refundDurationSeconds": Base64.stringify(Utf8.parse(vals.refundTimeoutSeconds))
            };
        }
    }

    var domainsData = resolveEnvConfigData()

    if (domainsData["env"] || DEMO_ENV == DEMO_ENV) {
        domainsData["ethscanPrefix"] = SEPOLIA_ETHERSCAN; // this will later be overidden by data from /info ep
    }
    resolvedConfig = domainsData as IConfig
    return resolvedConfig
};

export { getConfig, getSafeDomainData };

